module.exports = __webpack_public_path__ + "static/media/github.dac0634a.png";